import React from "react";
import Context from "../../../Context";
import Filters from "../../Misc/Filters";
import Blocker from "../../Misc/Blocker";
import allDocuments from "./typedoc";

export default class WorkdocFilters extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      peding: false,
      filters: false,
    };
  }

  makeFilters = async () => {
    let avDocuments = [];
    allDocuments.forEach((doc) => {
      if (doc.inTypedocList) {
        if (this.context.user.getClassAccess(doc.key)) {
          avDocuments.push({
            ...doc,
            active: false,
          });
        }
      }
    });

    let priorities = await this.context.api.qac("/priority");

    this.setState({
      peding: false,
      filters: {
        documents: avDocuments,
        active: [],
        native: [
          {
            id: "operdate",
            title: "По дате",
            kind: "range",
            active: false,
            value: [],
          },
          {
            active: false,
            id: "priority",
            title: "По приоритету",
            kind: "dropdown",
            variants: priorities.map((p) => [
              p.name,
              { field: "priority", value: p.id },
            ]),

            activeVariants: [],
          },
          {
            active: true,
            id: "statetypecode",
            title: "По статусу",
            kind: "dropdown",
            variants: [
              [
                "Кроме удаленных",
                {
                  lstr: "(",
                  field: "statetypecode",
                  valarr: ["created", "enabled", "disabled"],
                  rstr: ")",
                },
              ],
              [
                "Черновики",
                {
                  lstr: "(",
                  field: "statetypecode",
                  value: "created",
                  rstr: ")",
                },
              ],
              [
                "В работе",
                {
                  lstr: "(",
                  field: "statetypecode",
                  value: "enabled",
                  rstr: ")",
                },
              ],
              [
                "Завершены",
                {
                  lstr: "(",
                  field: "statetypecode",
                  value: "disabled",
                  rstr: ")",
                },
              ],
              [
                "Удалены",
                {
                  lstr: "(",
                  field: "statetypecode",
                  value: "deleted",
                  rstr: ")",
                },
              ],
            ],
            activeVariants: [0],
          },
        ],
      },
    });
  };

  componentDidMount() {
    this.makeFilters();
  }

  onDocumentToggle = (idx) => {
    this.setState(
      (state) => {
        let filters = state.filters || {};
        let documents = filters.documents || [];
        if (documents[idx]) {
          documents[idx].active = !documents[idx].active;
        }
        filters.documents = documents;
        return { filters };
      },
      () => this.applyFilters()
    );
  };

  handleFilters = (changedFilters) => {
    this.setState(
      (state) => {
        let filters = state.filters;
        filters.active = changedFilters;
        return { filters };
      },
      () => this.applyFilters()
    );
  };

  applyFilters = () => {
    let result = [...this.state.filters.active];
    let activeDocuments = [];
    this.state.filters.documents.forEach((item) => {
      if (item.active) {
        activeDocuments.push(item.key);
      }
    });
    if (activeDocuments.length > 0) {
      result.push({
        lstr: "(",
        field: "classcode",
        valarr: activeDocuments,
        rstr: ")",
      });
    }
    this.props.handleFilters(result);
  };

  render() {
    const { filters, peding } = this.state;
    return (
      <>
        <Blocker spinnerFixed on={peding}>
          {filters && (
            <div className="wide-filters">
              <b>По типу документа:</b>
              {filters.documents.map((item, idx) => {
                return (
                  <div className="mt-4" key={idx}>
                    <label className="checkbox">
                      <input
                        type="checkbox"
                        id="multiple"
                        onChange={() => this.onDocumentToggle(idx)}
                        checked={item.active}
                      />
                      <span className="mr-3"></span>
                      <div
                        className={`svg-icon   mr-2 opacity-50 svg-icon-${item.iconColor}`}
                      >
                        {item.icon}
                      </div>

                      {item.label}
                    </label>
                  </div>
                );
              })}
              <div className="mt-10">
                <b>По параметрам документа:</b>
              </div>
              <Filters
                key={JSON.stringify(filters.native)}
                filters={filters.native}
                changeFn={this.handleFilters}
              />
            </div>
          )}
        </Blocker>
      </>
    );
  }
}
